import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import SoldItems from '~/apps/smartsend/components/smartsend/SoldItems';
import RequireCustomer from '../layouts/my-account/require-customer';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { Suspense, useContext } from 'react';
import useLocalStorage from '~/hooks/use-local-storage';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { LocalStorageKeys } from '~/apps/smartsend/lib/consts/LocalStorageKeys';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { setValue: setIsSmartSendUser } = useLocalStorage(LocalStorageKeys.HasVisitedSmartSend, true);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const title = t('SOLD_ITEMS_PAGE_TITLE', { defaultValue: 'Sold Items' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: {
        title: title,
        currentPageRoute: RoutingConstants.SmartSend,
        showSmartActions: false // The SmartActions are auto included on the action bar.
      }
    });
    setIsSmartSendUser(true);
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.SmartSend
      }
    });
  });

  return (
    <Suspense>
      <RequireCustomer silent={false} isXs={isXs}>
        <Tagged tag="screen-sold-items">
          <SoldItems isXs={isXs} />
        </Tagged>
      </RequireCustomer>
    </Suspense>
  );
}

Component.displayName = 'Smart Send: Sold Items';
